(function () {

    'use strict';

    if (typeof window === 'undefined') {

        module.exports = exportFn(
            require('../modules/data/channels.js'),
            require('../modules/formatter.js'),
            require('../modules/sortFunctions.js'),
            require('../enums/facebookAdCampaignObjectives.js'),
            require('../enums/colors.js'),
            require('../enums/likelyPromoted.js'),
            require('../enums/metrics.js'),
            require('../strings/strings.js'),
            require('../str.js'),
            require('../modules/utils/metric.js'),
            require('lodash')
        );

    } else {
        RivalIQ.metrics.definitions.facebookAds = exportFn(
            RivalIQ.data.channels,
            RivalIQ.formatter,
            RivalIQ.sortFunctions,
            RivalIQ.enums.facebookAdCampaignObjectives,
            RivalIQ.enums.colors,
            RivalIQ.enums.likelyPromoted,
            RivalIQ.enums,
            RivalIQ.strings,
            RivalIQ.str,
            RivalIQ.utils.metric,
            window._
        );
    }

    function exportFn(channels, formatter, sortFunctions, facebookAdCampaignObjectives, colors, likelyPromoted, metricEnums, strings, str, utils, _) {

        function spendFormatter(value) {
            if (_.isArray(value)) {
                value = _.last(value);
            }

            return RivalIQ.formatter.formatAmountAndCurrency(value);
        }

        const spendSort = _.constant(sortFunctions.numericValueSort(function (obj) {
            return Number(_.get(obj, 'value', 0));
        }));

        const numberConvertSort = _.constant(sortFunctions.numericValueSort(function (value) {
            if (value) {
                return Number(value);
            }
            return value;
        }));

        function dateTimeFormatter(value, timezone) {
            const timezoneUtils = (typeof window === 'undefined') ? require('../modules/utils/timezone.js') : window.RivalIQ.utils.timezone;
            return timezoneUtils.getDateInTimezone(timezone || 'UTC', value).format('lll');
        }

        const actions = [
            'checkin',
            'comment',
            'leadgen_grouped',
            'landing_page_view',
            'like',
            'link_click',
            'mobile_app_install',
            'post_reaction',
            'page_engagement',
            'post_engagement',
            'offsite_conversion',
            'offsite_conversion__fb_pixel_view_content',
            'offsite_conversion__fb_pixel_search',
            'offsite_conversion__fb_pixel_add_to_cart',
            'offsite_conversion__fb_pixel_add_to_wishlist',
            'offsite_conversion__fb_pixel_initiate_checkout',
            'offsite_conversion__fb_pixel_add_payment_info',
            'offsite_conversion__fb_pixel_purchase',
            'offsite_conversion__fb_pixel_lead',
            'offsite_conversion__fb_pixel_complete_registration',
            'onsite_conversion__messaging_conversation_started_7d',
            'rsvp',
            'video_view'
        ];

        const actionMetrics = _.reduce(actions, function (memo, action) {
            memo[`actions_${action}`] = {
                name: strings[`facebook_ads_insights_actions_${action}_title`],
                description: strings[`facebook_ads_insights_actions_${action}_description`]
            };
            memo[`unique_actions_${action}`] = {
                name: strings[`facebook_ads_insights_unique_actions_${action}_title`],
                description: strings[`facebook_ads_insights_unique_actions_${action}_description`]
            };
            memo[`cost_per_action_type_${action}`] = {
                type: metricEnums.dataType.CURRENCY,
                format: spendFormatter,
                sort: spendSort,
                name: strings[`facebook_ads_insights_cost_per_action_type_${action}_title`],
                description: strings[`facebook_ads_insights_cost_per_action_type_${action}_description`]
            };
            memo[`cost_per_unique_action_type_${action}`] = {
                type: metricEnums.dataType.CURRENCY,
                format: spendFormatter,
                sort: spendSort,
                name: strings[`facebook_ads_insights_cost_per_unique_action_type_${action}_title`],
                description: strings[`facebook_ads_insights_cost_per_unique_action_type_${action}_description`]
            };

            return memo;
        }, {});

        const metrics = {
            account_id: {
                type: metricEnums.dataType.STRING,
                name: strings.facebook_ads_insights_account_id_title,
                description: strings.facebook_ads_insights_account_id_description
            },
            account_name: {
                type: metricEnums.dataType.STRING,
                name: strings.facebook_ads_insights_account_name_title,
                description: strings.facebook_ads_insights_account_name_description
            },
            action_values_offsite_conversion: {
                type: metricEnums.dataType.CURRENCY,
                format: spendFormatter,
                sort: spendSort,
                name: strings.facebook_ads_insights_action_values_offsite_conversion_title,
                description: strings.facebook_ads_insights_action_values_offsite_conversion_description
            },
            action_values_offsite_conversion__fb_pixel_view_content: {
                type: metricEnums.dataType.CURRENCY,
                format: spendFormatter,
                sort: spendSort,
                name: strings.facebook_ads_insights_action_values_offsite_conversion__fb_pixel_view_content_title,
                description: strings.facebook_ads_insights_action_values_offsite_conversion__fb_pixel_view_content_description
            },
            action_values_offsite_conversion__fb_pixel_search: {
                type: metricEnums.dataType.CURRENCY,
                format: spendFormatter,
                sort: spendSort,
                name: strings.facebook_ads_insights_action_values_offsite_conversion__fb_pixel_search_title,
                description: strings.facebook_ads_insights_action_values_offsite_conversion__fb_pixel_search_description
            },
            action_values_offsite_conversion__fb_pixel_add_to_cart: {
                type: metricEnums.dataType.CURRENCY,
                format: spendFormatter,
                sort: spendSort,
                name: strings.facebook_ads_insights_action_values_offsite_conversion__fb_pixel_add_to_cart_title,
                description: strings.facebook_ads_insights_action_values_offsite_conversion__fb_pixel_add_to_cart_description
            },
            action_values_offsite_conversion__fb_pixel_add_to_wishlist: {
                type: metricEnums.dataType.CURRENCY,
                format: spendFormatter,
                sort: spendSort,
                name: strings.facebook_ads_insights_action_values_offsite_conversion__fb_pixel_add_to_wishlist_title,
                description: strings.facebook_ads_insights_action_values_offsite_conversion__fb_pixel_add_to_wishlist_description
            },
            action_values_offsite_conversion__fb_pixel_initiate_checkout: {
                type: metricEnums.dataType.CURRENCY,
                format: spendFormatter,
                sort: spendSort,
                name: strings.facebook_ads_insights_action_values_offsite_conversion__fb_pixel_initiate_checkout_title,
                description: strings.facebook_ads_insights_action_values_offsite_conversion__fb_pixel_initiate_checkout_description
            },
            action_values_offsite_conversion__fb_pixel_add_payment_info: {
                type: metricEnums.dataType.CURRENCY,
                format: spendFormatter,
                sort: spendSort,
                name: strings.facebook_ads_insights_action_values_offsite_conversion__fb_pixel_add_payment_info_title,
                description: strings.facebook_ads_insights_action_values_offsite_conversion__fb_pixel_add_payment_info_description
            },
            action_values_offsite_conversion__fb_pixel_purchase: {
                type: metricEnums.dataType.CURRENCY,
                format: spendFormatter,
                sort: spendSort,
                name: strings.facebook_ads_insights_action_values_offsite_conversion__fb_pixel_purchase_title,
                description: strings.facebook_ads_insights_action_values_offsite_conversion__fb_pixel_purchase_description
            },
            action_values_offsite_conversion__fb_pixel_lead: {
                type: metricEnums.dataType.CURRENCY,
                format: spendFormatter,
                sort: spendSort,
                name: strings.facebook_ads_insights_action_values_offsite_conversion__fb_pixel_lead_title,
                description: strings.facebook_ads_insights_action_values_offsite_conversion__fb_pixel_lead_description
            },
            action_values_offsite_conversion__fb_pixel_complete_registration: {
                type: metricEnums.dataType.CURRENCY,
                format: spendFormatter,
                sort: spendSort,
                name: strings.facebook_ads_insights_action_values_offsite_conversion__fb_pixel_complete_registration_title,
                description: strings.facebook_ads_insights_action_values_offsite_conversion__fb_pixel_complete_registration_description
            },

            purchase_roas_omni_purchase: {
                type: metricEnums.dataType.NUMERIC,
                name: strings.facebook_ads_insights_purchase_roas_omni_purchase_title,
                description: strings.facebook_ads_insights_purchase_roas_omni_purchase_description
            },

            ad_id: {
                type: metricEnums.dataType.STRING,
                name: strings.facebook_ads_insights_ad_id_title,
                description: strings.facebook_ads_insights_ad_id_description
            },

            ad_name: {
                type: metricEnums.dataType.STRING,
                name: strings.facebook_ads_insights_ad_name_title,
                description: strings.facebook_ads_insights_ad_name_description
            },
            ad_body: {
                type: metricEnums.dataType.STRING,
                name: strings.facebook_ads_insights_ad_body_title,
                description: strings.facebook_ads_insights_ad_body_description
            },
            ad_title: {
                type: metricEnums.dataType.STRING,
                name: strings.facebook_ads_insights_ad_title_title,
                description: strings.facebook_ads_insights_ad_title_description
            },
            adset_id: {
                type: metricEnums.dataType.STRING,
                name: strings.facebook_ads_insights_adset_id_title,
                description: strings.facebook_ads_insights_adset_id_description
            },
            adset_name: {
                type: metricEnums.dataType.STRING,
                name: strings.facebook_ads_insights_adset_name_title,
                description: strings.facebook_ads_insights_adset_name_description
            },
            buying_type: {
                type: metricEnums.dataType.STRING,
                name: strings.facebook_ads_insights_buying_type_title,
                description: strings.facebook_ads_insights_buying_type_description
            },
            campaign_id: {
                type: metricEnums.dataType.STRING,
                name: strings.facebook_ads_insights_campaign_id_title,
                description: strings.facebook_ads_insights_campaign_id_description
            },
            campaign_name: {
                type: metricEnums.dataType.STRING,
                name: strings.facebook_ads_insights_campaign_name_title,
                description: strings.facebook_ads_insights_campaign_name_description
            },
            canvas_avg_view_percent: {
                type: metricEnums.dataType.NUMERIC,
                name: strings.facebook_ads_insights_canvas_avg_view_percent_title,
                description: strings.facebook_ads_insights_canvas_avg_view_percent_description
            },
            canvas_avg_view_time: {
                type: metricEnums.dataType.NUMERIC,
                name: strings.facebook_ads_insights_canvas_avg_view_time_title,
                description: strings.facebook_ads_insights_canvas_avg_view_time_description
            },
            // 'canvas_component_avg_pct_view',
            clicks: {
                type: metricEnums.dataType.INTEGER,
                name: strings.facebook_ads_insights_clicks_title,
                description: strings.facebook_ads_insights_clicks_description
            },

            cost_per_thruplay_video_view: {
                type: metricEnums.dataType.CURRENCY,
                format: spendFormatter,
                sort: spendSort,
                name: strings.facebook_ads_insights_cost_per_thruplay_video_view_title,
                description: strings.facebook_ads_insights_cost_per_thruplay_video_view_description
            },

            cost_per_estimated_ad_recallers: {
                type: metricEnums.dataType.CURRENCY,
                format: spendFormatter,
                sort: spendSort,
                name: strings.facebook_ads_insights_cost_per_estimated_ad_recallers_title,
                description: strings.facebook_ads_insights_cost_per_estimated_ad_recallers_description
            },
            cost_per_inline_link_click: {
                type: metricEnums.dataType.CURRENCY,
                format: spendFormatter,
                sort: spendSort,
                name: strings.facebook_ads_insights_cost_per_inline_link_click_title,
                description: strings.facebook_ads_insights_cost_per_inline_link_click_description
            },
            cost_per_inline_post_engagement: {
                type: metricEnums.dataType.CURRENCY,
                format: spendFormatter,
                sort: spendSort,
                name: strings.facebook_ads_insights_cost_per_inline_post_engagement_title,
                description: strings.facebook_ads_insights_cost_per_inline_post_engagement_description
            },

            cost_per_unique_click: {
                type: metricEnums.dataType.CURRENCY,
                format: spendFormatter,
                sort: spendSort,
                name: strings.facebook_ads_insights_cost_per_unique_click_title,
                description: strings.facebook_ads_insights_cost_per_unique_click_description
            },
            cost_per_unique_inline_link_click: {
                type: metricEnums.dataType.CURRENCY,
                format: spendFormatter,
                sort: spendSort,
                name: strings.facebook_ads_insights_cost_per_unique_inline_link_click_title,
                description: strings.facebook_ads_insights_cost_per_unique_inline_link_click_description
            },
            cpc: {
                type: metricEnums.dataType.CURRENCY,
                format: spendFormatter,
                sort: spendSort,
                name: strings.facebook_ads_insights_cpc_title,
                description: strings.facebook_ads_insights_cpc_description
            },
            cpm: {
                type: metricEnums.dataType.CURRENCY,
                format: spendFormatter,
                sort: spendSort,
                name: strings.facebook_ads_insights_cpm_title,
                description: strings.facebook_ads_insights_cpm_description
            },
            cpp: {
                type: metricEnums.dataType.CURRENCY,
                format: spendFormatter,
                sort: spendSort,
                name: strings.facebook_ads_insights_cpp_title,
                description: strings.facebook_ads_insights_cpp_description
            },
            ctr: {
                type: metricEnums.dataType.ABSOLUTE_PERCENT,
                format: formatter.absolutePercent,
                name: strings.facebook_ads_insights_ctr_title,
                description: strings.facebook_ads_insights_ctr_description
            },
            date_start: {
                type: metricEnums.dataType.STRING,
                name: strings.facebook_ads_insights_date_start_title,
                description: strings.facebook_ads_insights_date_start_description
            },
            date_stop: {
                type: metricEnums.dataType.STRING,
                name: strings.facebook_ads_insights_date_stop_title,
                description: strings.facebook_ads_insights_date_stop_description
            },
            engagement_rate: {
                name: strings.facebook_ads_insights_engagement_rate_title,
                description: strings.facebook_ads_insights_engagement_rate_description
            },
            estimated_ad_recall_rate: {
                type: metricEnums.dataType.NUMERIC,
                name: strings.facebook_ads_insights_estimated_ad_recall_rate_title,
                description: strings.facebook_ads_insights_estimated_ad_recall_rate_description
            },
            estimated_ad_recallers: {
                type: metricEnums.dataType.NUMERIC,
                name: strings.facebook_ads_insights_estimated_ad_recallers_title,
                description: strings.facebook_ads_insights_estimated_ad_recallers_description
            },
            frequency: {
                type: metricEnums.dataType.NUMERIC,
                name: strings.facebook_ads_insights_frequency_title,
                description: strings.facebook_ads_insights_frequency_description
            },
            impressions: {
                type: metricEnums.dataType.INTEGER,
                name: strings.facebook_ads_insights_impressions_title,
                description: strings.facebook_ads_insights_impressions_description
            },
            inline_link_click_ctr: {
                type: metricEnums.dataType.NUMERIC,
                format: formatter.absolutePercent,
                name: strings.facebook_ads_insights_inline_link_click_ctr_title,
                description: strings.facebook_ads_insights_inline_link_click_ctr_description
            },
            inline_link_clicks: {
                type: metricEnums.dataType.INTEGER,
                name: strings.facebook_ads_insights_inline_link_clicks_title,
                description: strings.facebook_ads_insights_inline_link_clicks_description
            },
            inline_post_engagement: {
                name: strings.facebook_ads_insights_inline_post_engagement_title,
                description: strings.facebook_ads_insights_inline_post_engagement_description
            },
            objective: {
                type: metricEnums.dataType.STRING,
                name: strings.facebook_ads_insights_objective_title,
                description: strings.facebook_ads_insights_objective_description,
                format: function (objective) {
                    return _.get(facebookAdCampaignObjectives, [objective, 'name'], objective);
                }
            },
            optimization_goal: {
                type: metricEnums.dataType.STRING,
                name: strings.facebook_ads_insights_optimization_goal_title,
                description: strings.facebook_ads_insights_optimization_goal_description
            },
            place_page_name: {
                type: metricEnums.dataType.STRING,
                name: strings.facebook_ads_insights_place_page_name_title,
                description: strings.facebook_ads_insights_place_page_name_description
            },
            reach: {
                type: metricEnums.dataType.INTEGER,
                name: strings.facebook_ads_insights_reach_title,
                description: strings.facebook_ads_insights_reach_description
            },
            social_spend: {
                type: metricEnums.dataType.CURRENCY,
                format: spendFormatter,
                sort: spendSort,
                name: strings.facebook_ads_insights_social_spend_title,
                description: strings.facebook_ads_insights_social_spend_description
            },
            spend: {
                type: metricEnums.dataType.CURRENCY,
                format: spendFormatter,
                sort: spendSort,
                name: strings.facebook_ads_insights_spend_title,
                description: strings.facebook_ads_insights_spend_description
            },
            unique_clicks: {
                type: metricEnums.dataType.INTEGER,
                name: strings.facebook_ads_insights_unique_clicks_title,
                description: strings.facebook_ads_insights_unique_clicks_description
            },
            unique_ctr: {
                type: metricEnums.dataType.NUMERIC,
                format: formatter.absolutePercent,
                name: strings.facebook_ads_insights_unique_ctr_title,
                description: strings.facebook_ads_insights_unique_ctr_description
            },
            unique_inline_link_click_ctr: {
                type: metricEnums.dataType.NUMERIC,
                format: formatter.absolutePercent,
                name: strings.facebook_ads_insights_unique_inline_link_click_ctr_title,
                description: strings.facebook_ads_insights_unique_inline_link_click_ctr_description
            },
            unique_inline_link_clicks: {
                type: metricEnums.dataType.INTEGER,
                name: strings.facebook_ads_insights_unique_inline_link_clicks_title,
                description: strings.facebook_ads_insights_unique_inline_link_clicks_description
            },
            unique_link_clicks_ctr: {
                type: metricEnums.dataType.NUMERIC,
                format: formatter.absolutePercent,
                name: strings.facebook_ads_insights_unique_link_clicks_ctr_title,
                description: strings.facebook_ads_insights_unique_link_clicks_ctr_description
            },
            video_thruplay_watched_actions_video_view: {
                type: metricEnums.dataType.INTEGER,
                name: strings.facebook_ads_insights_video_thruplay_watched_actions_video_view_title,
                description: strings.facebook_ads_insights_video_thruplay_watched_actions_video_view_description
            },
            video_30_sec_watched_actions_video_view: {
                type: metricEnums.dataType.INTEGER,
                name: strings.facebook_ads_insights_video_30_sec_watched_actions_video_view_title,
                description: strings.facebook_ads_insights_video_30_sec_watched_actions_video_view_description
            },
            video_avg_time_watched_actions_video_view: {
                type: metricEnums.dataType.NUMERIC,
                name: strings.facebook_ads_insights_video_avg_time_watched_actions_video_view_title,
                description: strings.facebook_ads_insights_video_avg_time_watched_actions_video_view_description
            },
            video_p100_watched_actions_video_view: {
                type: metricEnums.dataType.NUMERIC,
                name: strings.facebook_ads_insights_video_p100_watched_actions_video_view_title,
                description: strings.facebook_ads_insights_video_p100_watched_actions_video_view_description
            },
            video_p25_watched_actions_video_view: {
                type: metricEnums.dataType.NUMERIC,
                name: strings.facebook_ads_insights_video_p25_watched_actions_video_view_title,
                description: strings.facebook_ads_insights_video_p25_watched_actions_video_view_description
            },
            video_p50_watched_actions_video_view: {
                type: metricEnums.dataType.NUMERIC,
                name: strings.facebook_ads_insights_video_p50_watched_actions_video_view_title,
                description: strings.facebook_ads_insights_video_p50_watched_actions_video_view_description
            },
            video_p75_watched_actions_video_view: {
                type: metricEnums.dataType.NUMERIC,
                name: strings.facebook_ads_insights_video_p75_watched_actions_video_view_title,
                description: strings.facebook_ads_insights_video_p75_watched_actions_video_view_description
            },
            website_ctr_link_click: {
                type: metricEnums.dataType.NUMERIC,
                format: formatter.absolutePercent,
                name: strings.facebook_ads_insights_website_ctr_link_click_title,
                description: strings.facebook_ads_insights_website_ctr_link_click_description
            },

            ////////////////////////////////////////////
            // ads insights metrics defined by RivalIQ

            spend_pct_of_overall: {
                type: metricEnums.dataType.NUMERIC,
                name: strings.facebook_ads_insights_spend_pct_of_overall_title,
                description: strings.facebook_ads_insights_spend_pct_of_overall_description,
                format: formatter.absolutePercent
            },
            cost_per_result: {
                type: metricEnums.dataType.CURRENCY,
                name: strings.facebook_ads_insights_cost_per_result_title,
                description: strings.facebook_ads_insights_cost_per_result_description,
                format: spendFormatter,
                sort: spendSort
            },
            results: {
                name: strings.facebook_ads_insights_results_title,
                description: strings.facebook_ads_insights_results_description,
                sort: spendSort,
                format: function (value) {
                    // this could look up the formatter assigned to value.propertyName; but for now, it's all the same
                    return formatter.formatAbbreviated(value.value);
                }
            },
            start_time: {
                type: metricEnums.dataType.STRING,
                name: strings.facebook_ads_insights_start_time_title,
                description: strings.facebook_ads_insights_start_time_description,
                format: (value, metric) => {
                    return dateTimeFormatter(value, metric?.timezone);
                }
            },
            stop_time: {
                type: metricEnums.dataType.STRING,
                name: strings.facebook_ads_insights_stop_time_title,
                description: strings.facebook_ads_insights_stop_time_description,
                format: (value, metric) => {
                    return dateTimeFormatter(value, metric?.timezone);
                }
            },
            lifetime_budget: {
                type: metricEnums.dataType.CURRENCY,
                format: spendFormatter,
                sort: spendSort,
                name: strings.facebook_ads_insights_lifetime_budget_title,
                description: strings.facebook_ads_insights_lifetime_budget_description
            }
        };

        _.each(metrics, function (metric) {
            if (metric.type === metricEnums.dataType.NUMERIC || metric.type === metricEnums.dataType.INTEGER) {
                metric.sort = numberConvertSort;
            }
        });

        return _.extend(actionMetrics, metrics);
    }
})();
